import { cn } from "@/shared/lib/utils";
import { GROUPS } from "../developer-api";
import { MethodBadge } from "./atoms";

export function Sidebar({
  selectedId,
  onSelect,
}: {
  selectedId: string;
  onSelect: (id: string) => void;
}) {
  return (
    <nav className="space-y-6">
      <div className="space-y-1">
        <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground px-2">
          API Playground
        </div>
        <div className="text-xs text-muted-foreground px-2">
          Pick an endpoint, fill in parameters, and send a live request.
        </div>
      </div>

      {GROUPS.map((g) => (
        <div key={g.id}>
          <div className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground mb-1 px-2">
            {g.title}
          </div>
          <ul className="space-y-0.5">
            {g.endpoints.map((e) => {
              const active = e.id === selectedId;
              return (
                <li key={e.id}>
                  <button
                    type="button"
                    onClick={() => onSelect(e.id)}
                    className={cn(
                      "w-full flex items-center gap-2 text-sm py-1.5 px-2 rounded transition-colors text-left",
                      active
                        ? "bg-muted text-foreground"
                        : "text-muted-foreground hover:text-foreground hover:bg-muted/50",
                    )}
                  >
                    <MethodBadge method={e.method} size="xs" />
                    <span className="truncate">{e.summary}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </nav>
  );
}
